(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-get-win-amount.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-get-win-amount.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const useDrawResultFromCurrentWagerDraw = svs.components.tipsen.hooksWager.useDrawResultFromCurrentWagerDraw;
const _svs$components$tipse = svs.components.tipsen.store.tipsenApi,
  useGetPlayerWagerQuery = _svs$components$tipse.useGetPlayerWagerQuery,
  useGetMarketplaceWagerdetailsQuery = _svs$components$tipse.useGetMarketplaceWagerdetailsQuery;
const format = svs.utils.format;
const getAddonDrawWinAmount = _ref => {
  var _addonBet$wins, _addonBet$wins2;
  let addonBet = _ref.addonBet,
    allDrawNumbers = _ref.allDrawNumbers,
    drawNumber = _ref.drawNumber;
  if (!drawNumber || !addonBet || !((_addonBet$wins = addonBet.wins) !== null && _addonBet$wins !== void 0 && _addonBet$wins.length) > 0 || !allDrawNumbers || !allDrawNumbers.size) {
    return 0;
  }
  let indexOfSelectedDraw = 0;
  for (const tempDrawNumber of allDrawNumbers) {
    if (tempDrawNumber === drawNumber) {
      break;
    }
    indexOfSelectedDraw++;
  }
  const relatedAddonDrawNumber = addonBet.addonCompletedDrawNumbers[indexOfSelectedDraw] || undefined;
  let addonWin = 0;
  addonBet === null || addonBet === void 0 || (_addonBet$wins2 = addonBet.wins) === null || _addonBet$wins2 === void 0 || _addonBet$wins2.forEach(win => {
    if (win.drawNumber === relatedAddonDrawNumber) {
      addonWin += parseInt(win.amount, 10);
    }
  });
  return addonWin;
};
const getWinAmountsForCurrentDraw = _ref2 => {
  let drawNumber = _ref2.drawNumber,
    productWins = _ref2.productWins,
    addonBet = _ref2.addonBet,
    allDrawNumbers = _ref2.allDrawNumbers;
  let productWinAmountForDraw = 0;
  let addOnWinAmountForDraw = 0;
  productWins === null || productWins === void 0 || productWins.forEach(productWin => {
    if (productWin.drawNumber === drawNumber) {
      productWinAmountForDraw += parseInt(productWin.amount, 10);
    }
  });
  addOnWinAmountForDraw = getAddonDrawWinAmount({
    addonBet,
    allDrawNumbers,
    drawNumber
  });
  const totalWinForDraw = productWinAmountForDraw + addOnWinAmountForDraw;
  return [productWinAmountForDraw, addOnWinAmountForDraw, totalWinForDraw];
};
const getGroupWinAmounts = function (drawNumber) {
  let groupWinAmounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const currentGroupWinAmounts = groupWinAmounts[drawNumber] || groupWinAmounts.total;
  const groupWinAmount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.group ? format.CurrencyFromJupiterString(currentGroupWinAmounts.group) : 0;
  const playerWinAmount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.share ? format.CurrencyFromJupiterString(currentGroupWinAmounts.share) : 0;
  const groupAddonWinamount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.sportkryssGroup ? format.CurrencyFromJupiterString(currentGroupWinAmounts.sportkryssGroup) : 0;
  const playerAddonWinamount = currentGroupWinAmounts !== null && currentGroupWinAmounts !== void 0 && currentGroupWinAmounts.sportkryssShare ? format.CurrencyFromJupiterString(currentGroupWinAmounts.sportkryssShare) : 0;
  const totalGroupWinAmount = format.CurrencyFromJupiterString(groupWinAmount + groupAddonWinamount);
  const totalPlayerWinAmount = format.CurrencyFromJupiterString(playerWinAmount + playerAddonWinamount);
  return {
    groupWinAmount,
    playerWinAmount,
    groupAddonWinamount,
    playerAddonWinamount,
    totalGroupWinAmount,
    totalPlayerWinAmount
  };
};

const calculateGroupWinAmounts = _ref3 => {
  let winDivisions = _ref3.winDivisions,
    winDivisionsRowCount = _ref3.winDivisionsRowCount,
    customerShareCount = _ref3.customerShareCount,
    totalShareCount = _ref3.totalShareCount,
    _ref3$rowPriceMulti = _ref3.rowPriceMulti,
    rowPriceMulti = _ref3$rowPriceMulti === void 0 ? 1 : _ref3$rowPriceMulti;
  let groupWinAmount = 0;
  let playerWinAmount = 0;
  if (!Array.isArray(winDivisions) || !Array.isArray(winDivisionsRowCount)) {
    return {
      groupWinAmount,
      playerWinAmount
    };
  }
  for (const _ref4 of winDivisions) {
    const winDiv = _ref4.winDiv;
    const winValue = _ref4.winValue;
    const winDivisionWinValue = (winDivisionsRowCount === null || winDivisionsRowCount === void 0 ? void 0 : winDivisionsRowCount[winDiv - 1]) * format.CurrencyFromJupiterString(winValue) * rowPriceMulti;
    const winDivisionShareValue = winDivisionWinValue / totalShareCount;
    playerWinAmount += winDivisionShareValue * customerShareCount;
    groupWinAmount += winDivisionShareValue * totalShareCount;
  }
  return {
    groupWinAmount: groupWinAmount.toFixed(2),
    playerWinAmount: playerWinAmount.toFixed(2)
  };
};
const calculatePlayerWinAmount = _ref5 => {
  let winDivisions = _ref5.winDivisions,
    winDivisionsRowCount = _ref5.winDivisionsRowCount,
    _ref5$rowPriceMulti = _ref5.rowPriceMulti,
    rowPriceMulti = _ref5$rowPriceMulti === void 0 ? 1 : _ref5$rowPriceMulti;
  let playerWinAmount = 0;
  if (!Array.isArray(winDivisions) || !Array.isArray(winDivisionsRowCount)) {
    return playerWinAmount;
  }
  for (const _ref6 of winDivisions) {
    const winDiv = _ref6.winDiv;
    const winValue = _ref6.winValue;
    playerWinAmount += (winDivisionsRowCount === null || winDivisionsRowCount === void 0 ? void 0 : winDivisionsRowCount[winDiv - 1]) * format.CurrencyFromJupiterString(winValue) * rowPriceMulti;
  }
  return playerWinAmount;
};
const useGetWinAmount = _ref7 => {
  let wagerId = _ref7.wagerId,
    winDivisionsRowCount = _ref7.winDivisionsRowCount,
    activeDrawNumber = _ref7.activeDrawNumber,
    allDrawNumbers = _ref7.allDrawNumbers,
    _ref7$hasMaskedOutcom = _ref7.hasMaskedOutcomes,
    hasMaskedOutcomes = _ref7$hasMaskedOutcom === void 0 ? false : _ref7$hasMaskedOutcom;
  const _useGetPlayerWagerQue = useGetPlayerWagerQuery({
      wagerId
    }, {
      skip: !wagerId
    }),
    wagerData = _useGetPlayerWagerQue.data;
  const _ref8 = wagerData !== null && wagerData !== void 0 ? wagerData : {},
    _ref8$addonBet = _ref8.addonBet,
    addonBet = _ref8$addonBet === void 0 ? {} : _ref8$addonBet,
    _ref8$productBet = _ref8.productBet,
    productBet = _ref8$productBet === void 0 ? {} : _ref8$productBet;
  const _productBet$completed = productBet.completedDrawNumbers,
    completedDrawNumbers = _productBet$completed === void 0 ? [] : _productBet$completed,
    drawNumber = productBet.drawNumber,
    gameBoard = productBet.gameBoard,
    isGroup = productBet.isGroup,
    _productBet$propertie = productBet.properties,
    properties = _productBet$propertie === void 0 ? {} : _productBet$propertie,
    productWins = productBet.wins;
  const currentDrawNumber = activeDrawNumber || drawNumber;
  const _ref9 = gameBoard || {},
    _ref9$rowPriceMulti = _ref9.rowPriceMulti,
    rowPriceMulti = _ref9$rowPriceMulti === void 0 ? 1 : _ref9$rowPriceMulti;
  const customerShareCount = properties.customerShareCount,
    totalShareCount = properties.totalShareCount,
    groupId = properties.groupId,
    _properties$groupWinA = properties.groupWinAmounts,
    groupWinAmounts = _properties$groupWinA === void 0 ? {} : _properties$groupWinA;
  const isDrawCompleted = completedDrawNumbers.includes(currentDrawNumber) && !hasMaskedOutcomes;

  const _useGetMarketplaceWag = useGetMarketplaceWagerdetailsQuery({
      groupId,
      wagerId
    }, {
      skip: !isGroup
    }),
    marketPlaceData = _useGetMarketplaceWag.data;

  const _useDrawResultFromCur = useDrawResultFromCurrentWagerDraw({
      wagerId
    }),
    _useDrawResultFromCur2 = _slicedToArray(_useDrawResultFromCur, 1),
    drawResultData = _useDrawResultFromCur2[0].data;
  const _drawResultData = _slicedToArray(drawResultData, 2),
    winDivisions = _drawResultData[1];
  let groupData;
  let winAmount = 0;
  let addonWinAmount = 0;
  let productWinAmount = 0;
  const isDrawCompleteAndUnmasked = isDrawCompleted && !hasMaskedOutcomes;
  if (isGroup) {
    var _ref0, _groupData$totalPlaye, _groupData, _groupData2;
    groupData = isDrawCompleteAndUnmasked ?
    getGroupWinAmounts(currentDrawNumber, groupWinAmounts) :
    calculateGroupWinAmounts({
      winDivisions,
      winDivisionsRowCount,
      customerShareCount,
      totalShareCount,
      rowPriceMulti
    });
    winAmount = (_ref0 = (_groupData$totalPlaye = (_groupData = groupData) === null || _groupData === void 0 ? void 0 : _groupData.totalPlayerWinAmount) !== null && _groupData$totalPlaye !== void 0 ? _groupData$totalPlaye : (_groupData2 = groupData) === null || _groupData2 === void 0 ? void 0 : _groupData2.playerWinAmount) !== null && _ref0 !== void 0 ? _ref0 : 0;
    groupData.groupName = marketPlaceData === null || marketPlaceData === void 0 ? void 0 : marketPlaceData.groupName;
  } else if (isDrawCompleteAndUnmasked) {
    const _getWinAmountsForCurr = getWinAmountsForCurrentDraw({
        drawNumber: currentDrawNumber,
        productWins,
        addonBet,
        allDrawNumbers
      }),
      _getWinAmountsForCurr2 = _slicedToArray(_getWinAmountsForCurr, 3),
      productWinAmountForDraw = _getWinAmountsForCurr2[0],
      addOnWinAmountForDraw = _getWinAmountsForCurr2[1],
      totalWinForDraw = _getWinAmountsForCurr2[2];
    winAmount = totalWinForDraw;
    addonWinAmount = addOnWinAmountForDraw;
    productWinAmount = productWinAmountForDraw;
  } else {
    winAmount = calculatePlayerWinAmount({
      winDivisions,
      winDivisionsRowCount,
      rowPriceMulti
    });
  }
  return {
    isDrawCompleted,
    currentDrawNumber,
    winAmount: format.CurrencyFromJupiterString(winAmount),
    groupData: groupData && Object.keys(groupData).length > 0 ? groupData : undefined,
    addonWinAmount,
    productWinAmount
  };
};
setGlobal('svs.components.poolBetting.hooks', {
  useGetWinAmount
});

 })(window);